module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('img', {
    staticClass: "header-img",
    attrs: {
      "src": require("../../../../assets/images/bg-top@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [(_vm.row.club_list.length == 0) ? _c('div', {
    staticClass: "no_club"
  }, [_c('div', {
    staticStyle: {
      "height": "3.56rem"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('div', {
    staticClass: "create_btn",
    on: {
      "click": _vm.toClub
    }
  }, [_vm._v("立即创建")])])]) : _vm._e(), _vm._v(" "), (_vm.row.club_list.length > 0) ? _c('div', {
    staticClass: "club"
  }, [_c('h1', [_vm._v(_vm._s(_vm.row.club.name))]), _vm._v(" "), _c('div', {
    staticClass: "level"
  }, [_c('h1', [_vm._v("俱乐部等级")]), _vm._v(" "), (_vm.row.club.bgrade == '一星') ? _c('img', {
    attrs: {
      "src": require("../../../../assets/images/icon-yixiji@2x.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.row.club.bgrade == '二星') ? _c('img', {
    attrs: {
      "src": require("../../../../assets/images/icon-yixiji@2x.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.row.club.bgrade == '二星') ? _c('img', {
    attrs: {
      "src": require("../../../../assets/images/icon-yixiji@2x.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.row.club.bgrade == '三星') ? _c('img', {
    attrs: {
      "src": require("../../../../assets/images/icon-yixiji@2x.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.row.club.bgrade == '三星') ? _c('img', {
    attrs: {
      "src": require("../../../../assets/images/icon-yixiji@2x.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.row.club.bgrade == '三星') ? _c('img', {
    attrs: {
      "src": require("../../../../assets/images/icon-yixiji@2x.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.row.club.bgrade == '四星') ? _c('img', {
    attrs: {
      "src": require("../../../../assets/images/icon-yixiji@2x.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.row.club.bgrade == '四星') ? _c('img', {
    attrs: {
      "src": require("../../../../assets/images/icon-yixiji@2x.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.row.club.bgrade == '四星') ? _c('img', {
    attrs: {
      "src": require("../../../../assets/images/icon-yixiji@2x.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.row.club.bgrade == '四星') ? _c('img', {
    attrs: {
      "src": require("../../../../assets/images/icon-yixiji@2x.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.row.club.bgrade == '五星') ? _c('img', {
    attrs: {
      "src": require("../../../../assets/images/icon-yixiji@2x.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.row.club.bgrade == '五星') ? _c('img', {
    attrs: {
      "src": require("../../../../assets/images/icon-yixiji@2x.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.row.club.bgrade == '五星') ? _c('img', {
    attrs: {
      "src": require("../../../../assets/images/icon-yixiji@2x.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.row.club.bgrade == '五星') ? _c('img', {
    attrs: {
      "src": require("../../../../assets/images/icon-yixiji@2x.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.row.club.bgrade == '五星') ? _c('img', {
    attrs: {
      "src": require("../../../../assets/images/icon-yixiji@2x.png"),
      "alt": ""
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "br"
  }), _vm._v(" "), _c('h2', [_vm._v("俱乐部人员情况")]), _vm._v(" "), _c('div', {
    staticClass: "club_detail"
  }, [_c('div', {
    staticClass: "detail_info"
  }, [_c('h1', [_vm._v(_vm._s(_vm.row.club.member.total))]), _vm._v(" "), _c('h2', [_vm._v("总人数")])]), _vm._v(" "), _c('div', {
    staticClass: "detail_info"
  }, [_c('h1', [_vm._v(_vm._s(_vm.row.club.member.add_member))]), _vm._v(" "), _c('h2', [_vm._v("今年新增人数")])]), _vm._v(" "), _c('div', {
    staticClass: "detail_info"
  }, [_c('h1', [_vm._v(_vm._s(_vm.row.club.member.activity_member))]), _vm._v(" "), _c('h2', [_vm._v("今年参与活动人数")])])]), _vm._v(" "), _c('div', {
    staticClass: "br",
    staticStyle: {
      "margin-top": "0.4rem"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.row.club.list.length > 0),
      expression: "row.club.list.length>0"
    }],
    staticClass: "my_detail"
  }, [_c('h2', [_vm._v("我的活动&比赛")]), _vm._v(" "), _vm._l((_vm.row.club.list), function(item, index) {
    return _c('div', {
      directives: [{
        name: "rblink",
        rawName: "v-rblink",
        value: ({
          'name': 'ISaiApplyDetail',
          'query': {
            id: item.id
          }
        }),
        expression: "{\n                  'name' : 'ISaiApplyDetail',\n                  'query':{\n                      id: item.id\n                  }}"
      }],
      key: index
    }, [_c('div', {
      staticClass: "br"
    }), _vm._v(" "), _c('div', {
      staticClass: "list_header"
    }, [_c('h1', [_vm._v(_vm._s(item.saiqu_name))]), _vm._v(" "), _c('div', {
      staticClass: "action_btn"
    }, [_vm._v("继续操作")])])])
  })], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.goClub
    }
  }, [_vm._v("管理俱乐部")]), _vm._v(" "), _c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.sheetActiveShow = true
      }
    }
  }, [_vm._v("切换俱乐部")]), _vm._v(" "), _c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.unbindClub()
      }
    }
  }, [_vm._v("解除绑定")])])]) : _vm._e(), _vm._v(" "), (_vm.row.center_list.length == 0) ? _c('div', {
    staticClass: "no_grade",
    staticStyle: {
      "margin-top": "0.3rem"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "3.56rem"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "create_btn",
    on: {
      "click": _vm.toKaoji
    }
  }, [_vm._v("立即创建")])]) : _vm._e(), _vm._v(" "), (_vm.row.center_list.length > 0) ? _c('div', {
    staticClass: "club",
    staticStyle: {
      "margin-top": "0.3rem"
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.row.center.danwei))]), _vm._v(" "), _c('div', {
    staticClass: "icon"
  }, [_vm._v(_vm._s(_vm.row.center.kaojitype))]), _vm._v(" "), _c('div', {
    staticClass: "br"
  }), _vm._v(" "), _c('h2', [_vm._v("考级中心/点人员情况")]), _vm._v(" "), _c('div', {
    staticClass: "club_detail"
  }, [_c('div', {
    staticClass: "detail_info"
  }, [_c('h1', [_vm._v(_vm._s(_vm.row.center.member.total))]), _vm._v(" "), _c('h2', [_vm._v("总人数")])]), _vm._v(" "), _c('div', {
    staticClass: "detail_info"
  }, [_c('h1', [_vm._v(_vm._s(_vm.row.center.member.add_member))]), _vm._v(" "), _c('h2', [_vm._v("今年新增人数")])]), _vm._v(" "), _c('div', {
    staticClass: "detail_info"
  }, [_c('h1', [_vm._v(_vm._s(_vm.row.center.member.activity_member))]), _vm._v(" "), _c('h2', [_vm._v("今年参与活动人数")])])]), _vm._v(" "), _c('div', {
    staticClass: "br",
    staticStyle: {
      "margin-top": "0.4rem"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.row.center.list.length > 0),
      expression: "row.center.list.length>0"
    }],
    staticClass: "my_detail"
  }, [_c('h2', [_vm._v("我的考级")]), _vm._v(" "), _vm._l((_vm.row.center.list), function(item, index) {
    return _c('div', {
      directives: [{
        name: "rblink",
        rawName: "v-rblink",
        value: ({
          name: 'ExameApplyDetailMine',
          query: {
            id: item.id
          }
        }),
        expression: "{\n          name:'ExameApplyDetailMine',\n          query:{\n            id:item.id\n          }\n        }"
      }],
      key: index
    }, [_c('div', {
      staticClass: "br"
    }), _vm._v(" "), _c('div', {
      staticClass: "list_header"
    }, [_c('h1', [_vm._v(_vm._s(item.saiqu_name))]), _vm._v(" "), _c('div', {
      staticClass: "action_btn"
    }, [_vm._v("继续操作")])])])
  })], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('div', {
    staticClass: "btn",
    staticStyle: {
      "width": "100px"
    },
    on: {
      "click": _vm.goCenter
    }
  }, [_vm._v("\n          管理考级中心\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.centerActiveShow = true
      }
    }
  }, [_vm._v("切换考级中心")]), _vm._v(" "), _c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.unbindCenter()
      }
    }
  }, [_vm._v("解除绑定")])])]) : _vm._e()]), _vm._v(" "), _c('van-dialog', {
    staticClass: "dialog-box",
    attrs: {
      "title": "",
      "showConfirmButton": false
    },
    model: {
      value: (_vm.clubShow),
      callback: function($$v) {
        _vm.clubShow = $$v
      },
      expression: "clubShow"
    }
  }, [_c('div', {
    staticClass: "dialog-head"
  }, [_vm._v("创建须知")]), _vm._v(" "), _c('div', {
    staticClass: "dialog-content"
  }, [_c('div', {
    staticClass: "dialog-step-li"
  }, [_vm._v("\n        附件下载\n        "), _vm._v(" "), _c('div', [_c('van-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.download(
          '啦啦操星级俱乐部管理办法',
          'https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1623833117774-11.pdf'
        )
      }
    }
  }, [_vm._v("\n            啦啦操星级俱乐部管理办法\n          ")])], 1)]), _vm._v(" "), _c('van-button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": function($event) {
        return _vm.toClubNext(0)
      }
    }
  }, [_c('div', [_vm._v("我已阅读并同意遵守本须知声明的所有条款")]), _vm._v(" "), _c('div', [_vm._v("点击进行创建")])]), _vm._v(" "), _c('van-button', {
    attrs: {
      "type": "default",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.clubShow = false
      }
    }
  }, [_vm._v("我再想想")])], 1)]), _vm._v(" "), _c('van-dialog', {
    staticClass: "dialog-box",
    attrs: {
      "title": "",
      "showConfirmButton": false
    },
    model: {
      value: (_vm.kaojiShow),
      callback: function($$v) {
        _vm.kaojiShow = $$v
      },
      expression: "kaojiShow"
    }
  }, [_c('div', {
    staticClass: "dialog-head"
  }, [_vm._v("创建须知")]), _vm._v(" "), _c('div', {
    staticClass: "dialog-content"
  }, [_c('div', {
    staticClass: "dialog-step-li"
  }, [_vm._v("1.可创建类型为：")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "dialog-li"
  }, [_c('div', {
    staticClass: "li-left"
  }, [_vm._v("（1）七彩星级指定考级点")]), _vm._v(" "), _c('div', {
    staticClass: "li-right"
  }, [_vm._v("0元")])]), _vm._v(" "), _c('li', {
    staticClass: "dialog-li"
  }, [_c('div', {
    staticClass: "li-left"
  }, [_vm._v("（2）七彩星级指定样板考级点")]), _vm._v(" "), _c('div', {
    staticClass: "li-right"
  }, [_vm._v("9800元")])]), _vm._v(" "), _c('li', {
    staticClass: "dialog-li"
  }, [_c('div', {
    staticClass: "li-left"
  }, [_vm._v("（3）七彩星级指定考级中心")]), _vm._v(" "), _c('div', {
    staticClass: "li-right"
  }, [_vm._v("120000元")])]), _vm._v(" "), _c('li', {
    staticClass: "dialog-li"
  }, [_c('div', {
    staticClass: "li-left"
  }, [_vm._v("（4）七彩星级指定样板考级中心")]), _vm._v(" "), _c('div', {
    staticClass: "li-right"
  }, [_vm._v("135000元")])])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-step-li"
  }, [_vm._v("\n        2.请确认您已准备好营业执照扫描件（.jpg或.png）/根据我们APP可以接收的图片格式进行设定/\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "dialog-step-li"
  }, [_vm._v("\n        3.附件下载\n        "), _c('div', {
    staticClass: "dialog-step-li-text",
    on: {
      "click": function($event) {
        return _vm.download(
          '啦啦操七彩星级管理办法',
          'https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1622687436968-14.pdf'
        )
      }
    }
  }, [_vm._v("\n          啦啦操七彩星级管理办法\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "dialog-step-li-text",
    on: {
      "click": function($event) {
        return _vm.download(
          '七彩星级考级中心（点）加盟方案',
          'https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1622687436968-12.pdf'
        )
      }
    }
  }, [_vm._v("\n          七彩星级考级中心（点）加盟方案\n        ")])]), _vm._v(" "), _c('van-button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": function($event) {
        return _vm.toKaojiNext(0)
      }
    }
  }, [_c('div', [_vm._v("我已阅读并同意遵守本须知声明的所有条款")]), _vm._v(" "), _c('div', [_vm._v("点击进行创建")])]), _vm._v(" "), _c('van-button', {
    attrs: {
      "type": "default",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.kaojiShow = false
      }
    }
  }, [_vm._v("我再想想")])], 1)]), _vm._v(" "), _c('van-action-sheet', {
    attrs: {
      "description": "将以新的俱乐部主体参赛报名",
      "actions": _vm.row.club_list,
      "cancel-text": "取消",
      "close-on-click-action": ""
    },
    on: {
      "cancel": _vm.onSheetCancel,
      "select": _vm.onSelect
    },
    model: {
      value: (_vm.sheetActiveShow),
      callback: function($$v) {
        _vm.sheetActiveShow = $$v
      },
      expression: "sheetActiveShow"
    }
  }), _vm._v(" "), _c('van-action-sheet', {
    attrs: {
      "description": "将以考级中心/点申报考级",
      "actions": _vm.row.center_list,
      "cancel-text": "取消",
      "close-on-click-action": ""
    },
    on: {
      "cancel": _vm.onSheetCancel,
      "select": _vm.onSelectCenter
    },
    model: {
      value: (_vm.centerActiveShow),
      callback: function($$v) {
        _vm.centerActiveShow = $$v
      },
      expression: "centerActiveShow"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": ""
    },
    on: {
      "click": _vm.toClub
    }
  }, [_vm._v("创建俱乐部\n    ")]), _vm._v(" "), _c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": ""
    },
    on: {
      "click": _vm.toKaoji
    }
  }, [_vm._v("创建考级中心（点）\n    ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-326081c6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/user/mine/club/MyClub.vue
// module id = 2295
// module chunks = 0